import React from 'react'
import { Backdrop } from '@mui/material'
import PropTypes from 'prop-types'
import { CircularProgress } from 'asterX-UI/Loaders/index'

const LoaderBackdrop = ({ loading }) => {
  return (
    loading && (
      <Backdrop open={loading} sx={{ zIndex: 99999 }}>
        <CircularProgress size={40} />
      </Backdrop>
    )
  )
}

LoaderBackdrop.propTypes = {
  loading: PropTypes.bool
}

export default LoaderBackdrop
